import * as React from 'react';
import { t } from 'i18next';
import OutlinedInput from '@mui/material/OutlinedInput';
import ApiManager from '../../libs/ApiManager';
import MultiSelect from '../utils/MultiSelect';
import ErrorMessageContext from '../context/ErrorMessageContext';

import '../../styles/DeviceSelect.scss';

function getDeviceType(type) {
    switch (type) {
        case 'viewer':
            return `[${t('form.device_type.viewer')}] `;
        case 'camera':
            return `[${t('form.device_type.camera')}] `;
        default:
            return '';
    }
}

function getDeviceName(device, showLabel = false) {
    const label = showLabel ? getDeviceType(device.type) : '';
    let model = device.device || '';
    if (device.os === 'embedded') {
        model = model.replace(/\s*\([^)]*\)\s*$/, '');
    }
    return `${label}${model} (${device.name})`
}

export default function DeviceSelect (mainProps) {
    const {
        placeholder,
        onChange,
        token,
        value,
        camera = false,
        viewer = false,
        multiple = false,
        inputProps,
        ...props
    } = mainProps;
    const { onError }  = React.useContext(ErrorMessageContext);
    const [options, setOptions] = React.useState([]);
    const [devices, setDevices] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    React.useEffect(() => {
        async function getDevices() {
            setIsLoading(true);
            try {
                const devices = await ApiManager.getDevices(token);
                setDevices(devices);
            } catch (err) {
                onError(err);
            }
            setIsLoading(false);
        }
        if (token) {
            getDevices();
        }
    }, [token]);

    React.useEffect(() => {
        let filtered = devices;
        let showLabel = false;
        if (camera && !viewer) {
            filtered = filtered.filter(device => device.type === 'camera');
        } else if (viewer && !camera) {
            filtered = filtered.filter(device => device.type === 'viewer');
        } else {
            showLabel = true;
        }
        setOptions(filtered.map((device) => ({ ...device, id: device.jid, label: <div className='device-select-option'><span className='text'>{getDeviceName(device, showLabel)}</span></div> })));
    }, [devices, camera, viewer]);

    const onSelectChange = (value) => {
        if (Array.isArray(value)) {
            onChange(value.map(id => devices.find(device => device.jid === id)));
        } else {
            onChange(devices.find(device => device.jid === value));
        }
    }

    return (
        <MultiSelect
          className='device-select'
          id='device-select'
          options={options}
          value={multiple ? (Array.isArray(value) ? value.map(v => v.jid).filter(Boolean) : []) : (value?.jid || '')}
          onChange={onSelectChange}
          placeholder={placeholder}
          multiple={multiple}
          input={<OutlinedInput placeholder={placeholder} inputProps={{ sx: { padding: '10px 15px', lineHeight: '34px' }}} />}
          {...props}
        />
    );
}